<template>
    <div class="offboarding">
        <template v-if="!UIState.isFinishDowngradeView && !UIState.isFinishCancelationView">
            <start-screen />
            <fusebox-features />
        </template>
        <template v-if="UIState.isFinishDowngradeView">
            <finish-screen name="FinishDowngrade">
                <template v-slot:image>
                    <svg-vue class="donwgrade-image" icon="finish-downgrade" />
                </template>
                <template v-slot:content>
                    <h2>All Done!</h2>
                    <p>You can now continue to use Fusebox on your website without any interruptions until <b>{{ subscriptionEndDate }}</b>.</p>
                    <p>Any Pro configurations that were previously enabled will automatically convert to the standard configuration.</p>
                    <base-submit-button
                        class="btn btn-primary"
                        @click="goToDashboard"
                    >
                        Go back to the Dashboard
                    </base-submit-button>
                </template>
            </finish-screen>
        </template>
        <template v-if="UIState.isFinishCancelationView">
            <finish-screen name="FinishCancelation">
                <template v-slot:image>
                    <svg-vue class="cancelation-image" icon="finish-cancelation" />
                </template>
                <template v-slot:content>
                    <h2>Thank you for using Fusebox!</h2>
                    <p>Your subscription will be cancelled on <b>{{ subscriptionEndDate }}</b>. You will receive an email confirmation shortly. We hoped you enjoyed using our products and hope to see you back soon!</p>
                    <p>
                        <!-- eslint-disable vue/singleline-html-element-content-newline -->
                        If you change your mind, simply go to the <router-link to="settings/billing">Billing page</router-link>, and click Resume Your Subscription.
                    </p>
                    <p>In the meantime, let's still be friends!</p>
                    <iframe
                        src="https://open.spotify.com/embed/track/5LxvwujISqiB8vpRYv887S"
                        width="100%"
                        max-width="400"
                        height="80"
                        frameborder="0"
                        allowtransparency="true"
                        allow="encrypted-media"
                    />
                    <base-submit-button
                        class="btn btn-primary"
                        @click="goToDashboard"
                    >
                        Go back to the Dashboard
                    </base-submit-button>
                </template>
            </finish-screen>
        </template>
    </div>
</template>

<script>
import moment from 'moment';
import { mapState, mapActions } from 'vuex';
import toasts from '@/mixins/toasts';
import StartScreen from '@/components/Dashboard/Offboarding/StartScreen';
import FuseboxFeatures from '@/components/Dashboard/Offboarding/FuseboxFeatures';
import FinishScreen from '@/components/Dashboard/Offboarding/FinishScreen';

export default {
    components: {
        StartScreen,
        FuseboxFeatures,
        FinishScreen,
    },

    mixins: [toasts],

    computed: {
        ...mapState(['UIState']),

        ...mapState({
            subscriptionEndDate: state =>
                state.userSubscription ? moment.unix(state.userSubscription.current_period_end).format('MMMM D, YYYY') : '',
        }),
    },

    methods: {
        ...mapActions(['logOut']),

        /**
         * Navigate User to dashboard
         */
        goToDashboard() {
            this.$router.push('/');
        },
    },
};
</script>
